import axios from "axios";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import ReactDOM from "react-dom";

const FormularioAmigo = () => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const [respuestaServidor, setRespuestaServidor] = useState({
        type: "",
        message: "",
    });
    const [btnText, setBtnText] = useState("ENVIAR MENSAJE");
    const [inputDisabled, setInputDisabled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    // Manejar apertura del modal
    useEffect(() => {
        // Buscar botones que abren el modal
        const toggleButtons = document.querySelectorAll('[data-modal-toggle="form-refiere"]');

        const handleOpen = (e) => {
            e.preventDefault();
            setIsOpen(true);
        };

        toggleButtons.forEach(button => {
            button.addEventListener('click', handleOpen);
        });

        // Cleanup
        return () => {
            toggleButtons.forEach(button => {
                button.removeEventListener('click', handleOpen);
            });
        };
    }, []);

    // Manejar scroll del body cuando el modal se abre/cierra
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        // Cleanup
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    // Manejar tecla ESC
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === 'Escape' && isOpen) {
                closeModal();
            }
        };

        document.addEventListener('keydown', handleEsc);
        return () => document.removeEventListener('keydown', handleEsc);
    }, [isOpen]);

    const closeModal = () => {
        setIsOpen(false);
        setRespuestaServidor({ type: "", message: "" });
    };

    const checkPhone = (phone) => {
        if (phone.length != 9) {
            return "El teléfono debe tener 9 digitos";
        }
        if (!/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g.test(phone)) {
            return "Debes ingresar un teléfono válido";
        }
    };

    const checkRut = (rut) => {
        if (!rut) {
            return false;
        }
        let valor = rut.replaceAll(".", "");
        valor = valor.replaceAll("-", "");
        const cuerpo = valor.slice(0, -1);
        let dv = valor.slice(-1).toUpperCase();
        rut = cuerpo + "-" + dv;

        if (cuerpo.length < 7) {
            return "RUT Incompleto";
        }

        let suma = 0;
        let multiplo = 2;

        for (let i = 1; i <= cuerpo.length; i++) {
            let index = multiplo * valor.charAt(cuerpo.length - i);
            suma = suma + index;
            if (multiplo < 7) {
                multiplo = multiplo + 1;
            } else {
                multiplo = 2;
            }
        }

        const dvEsperado = 11 - (suma % 11);
        dv = dv == "K" ? 10 : dv;
        dv = dv == 0 ? 11 : dv;

        if (dvEsperado != dv) {
            return "RUT Inválido";
        }
        return true;
    };

    const formatRut = (event) => {
        event.target.value = event.target.value
            .replace(/[.-]/g, "")
            .replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, "$1.$2.$3-$4")
            .toUpperCase();
    };

    const enviarDatos = (data) => {
        setBtnText("ENVIANDO...");
        setInputDisabled(true);
        axios
            .post(`/envios/incio/contacto-amigo`, data)
            .then((response) => {
                const data = response.data;
                setRespuestaServidor({
                    type: "success",
                    message: data.message,
                });
                reset();
                // Cerrar modal después de 3 segundos
                setTimeout(closeModal, 3000);
            })
            .catch((error) => {
                setRespuestaServidor({
                    type: "danger",
                    message: error.response?.data?.message || "Error al enviar el formulario",
                });
            })
            .finally(() => {
                setBtnText("ENVIAR MENSAJE");
                setInputDisabled(false);
            });
    };

    // Si el modal no está abierto, no renderizar nada
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-gray-900/50 z-40"
                onClick={closeModal}
            />

            {/* Modal */}
            <div className="fixed inset-0 z-50 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4">
                    <div className="relative w-full max-w-4xl bg-white rounded-lg shadow-xl dark:bg-gray-700">

                        {/* Header */}
                        <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
                            <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                                Refiere a un Amigo
                            </h3>
                            <button
                                type="button"
                                onClick={closeModal}
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                                <svg className="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                                </svg>
                                <span className="sr-only">Cerrar modal</span>
                            </button>
                        </div>

                        {/* Body */}
                        <div className="p-4 md:p-5">
                            <form onSubmit={handleSubmit(enviarDatos)}>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                    {/* Nombre */}
                                    <div className="w-full">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                className={`peer w-full px-4 pt-6 pb-2 border rounded-lg bg-white text-gray-900 placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
                                                ${errors.nombre ? "border-red-500" : "border-gray-300"}`}
                                                name="nombre"
                                                placeholder="INGRESA TU NOMBRE"
                                                disabled={inputDisabled}
                                                {...register("nombre", {
                                                    required: "Debes ingresar tu nombre",
                                                })}
                                            />
                                            <label
                                                className="absolute left-4 top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs">
                                                INGRESA TU NOMBRE
                                            </label>
                                        </div>
                                        {errors.nombre && (
                                            <p className="mt-1 text-sm text-red-600">
                                                {errors.nombre.message}
                                            </p>
                                        )}
                                    </div>

                                    {/* Email */}
                                    <div className="w-full">
                                        <div className="relative">
                                            <input
                                                type="email"
                                                className={`peer w-full px-4 pt-6 pb-2 border rounded-lg bg-white text-gray-900 placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
                                                ${errors.email ? "border-red-500" : "border-gray-300"}`}
                                                name="email"
                                                disabled={inputDisabled}
                                                {...register("email", {
                                                    required: "Debes ingresar tu email",
                                                    pattern: {
                                                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                        message: "Debes ingresar un email válido",
                                                    },
                                                })}
                                                placeholder="INGRESA TU EMAIL"
                                            />
                                            <label
                                                className="absolute left-4 top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs">
                                                INGRESA TU EMAIL
                                            </label>
                                        </div>
                                        {errors.email && (
                                            <p className="mt-1 text-sm text-red-600">
                                                {errors.email.message}
                                            </p>
                                        )}
                                    </div>

                                    {/* Teléfono */}
                                    <div className="w-full">
                                        <div className="relative flex">
                                            <span className="inline-flex items-center px-3 border border-r-0 border-gray-300 rounded-l-lg bg-gray-100 text-gray-600 text-sm">
                                                +56
                                            </span>
                                            <div className="relative flex-1">
                                                <input
                                                    type="text"
                                                    className={`peer w-full px-4 pt-6 pb-2 border rounded-r-lg bg-white text-gray-900 placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
                                                    ${errors.fono ? "border-red-500" : "border-gray-300"}`}
                                                    name="fono"
                                                    disabled={inputDisabled}
                                                    placeholder="INGRESA TU TELÉFONO"
                                                    {...register("fono", {
                                                        required: "Debes ingresar tu teléfono",
                                                        validate: checkPhone,
                                                    })}
                                                />
                                                <label
                                                    className="absolute left-4 top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs">
                                                    INGRESA TU TELÉFONO
                                                </label>
                                            </div>
                                        </div>
                                        {errors.fono && (
                                            <p className="mt-1 text-sm text-red-600">
                                                {errors.fono.message}
                                            </p>
                                        )}
                                    </div>

                                    {/* RUT */}
                                    <div className="w-full">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                className={`peer w-full px-4 pt-6 pb-2 border rounded-lg bg-white text-gray-900 placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
                                                ${errors.rut ? "border-red-500" : "border-gray-300"}`}
                                                name="rut"
                                                disabled={inputDisabled}
                                                placeholder="INGRESA TU RUT"
                                                {...register("rut", {
                                                    required: "Debes ingresar tu rut",
                                                    validate: checkRut,
                                                })}
                                                onChange={formatRut}
                                            />
                                            <label
                                                className="absolute left-4 top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs">
                                                INGRESA TU RUT
                                            </label>
                                        </div>
                                        {errors.rut && (
                                            <p className="mt-1 text-sm text-red-600">
                                                {errors.rut.message}
                                            </p>
                                        )}
                                    </div>

                                    {/* Nombre del amigo */}
                                    <div className="w-full">
                                        <div className="relative">
                                            <input
                                                type="text"
                                                className={`peer w-full px-4 pt-6 pb-2 border rounded-lg bg-white text-gray-900 placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
                                                ${errors.nombre_amigo ? "border-red-500" : "border-gray-300"}`}
                                                name="nombre_amigo"
                                                disabled={inputDisabled}
                                                placeholder="NOMBRE DE TU AMIGO"
                                                {...register("nombre_amigo", {
                                                    required: "Debes ingresar el nombre de tu amigo",
                                                })}
                                            />
                                            <label
                                                className="absolute left-4 top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs">
                                                NOMBRE DE TU AMIGO
                                            </label>
                                        </div>
                                        {errors.nombre_amigo && (
                                            <p className="mt-1 text-sm text-red-600">
                                                {errors.nombre_amigo.message}
                                            </p>
                                        )}
                                    </div>

                                    {/* Email del amigo */}
                                    <div className="w-full">
                                        <div className="relative">
                                            <input
                                                type="email"
                                                className={`peer w-full px-4 pt-6 pb-2 border rounded-lg bg-white text-gray-900 placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all
                                                ${errors.email_amigo ? "border-red-500" : "border-gray-300"}`}
                                                name="email_amigo"
                                                disabled={inputDisabled}
                                                {...register("email_amigo", {
                                                    required: "Debes ingresar el email de tu amigo",
                                                    pattern: {
                                                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                        message: "Debes ingresar un email válido",
                                                    },
                                                })}
                                                placeholder="EMAIL DE TU AMIGO"
                                            />
                                            <label
                                                className="absolute left-4 top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs">
                                                EMAIL DE TU AMIGO
                                            </label>
                                        </div>
                                        {errors.email_amigo && (
                                            <p className="mt-1 text-sm text-red-600">
                                                {errors.email_amigo.message}
                                            </p>
                                        )}
                                    </div>

                                    {/* Mensaje */}
                                    <div className="col-span-1 md:col-span-2">
                                        <div className="relative">
                                            <textarea
                                                className={`peer w-full px-4 pt-6 pb-2 border rounded-lg bg-white text-gray-900 placeholder-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all min-h-[120px] resize-y
                                                ${errors.mensaje ? "border-red-500" : "border-gray-300"}`}
                                                placeholder="INGRESA TU MENSAJE"
                                                disabled={inputDisabled}
                                                name="mensaje"
                                                {...register("mensaje", {
                                                    required: "Debes ingresar el mensaje",
                                                })}
                                            ></textarea>
                                            <label
                                                className="absolute left-4 top-2 text-xs text-gray-500 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:top-4 peer-focus:top-2 peer-focus:text-xs">
                                                INGRESA TU MENSAJE
                                            </label>
                                        </div>
                                        {errors.mensaje && (
                                            <p className="mt-1 text-sm text-red-600">
                                                {errors.mensaje.message}
                                            </p>
                                        )}
                                    </div>

                                    {/* Botón Submit */}
                                    <div className="col-span-1 md:col-span-2 flex justify-center">
                                        <button
                                            type="submit"
                                            className="w-full md:w-1/3 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                            disabled={inputDisabled}
                                        >
                                            {btnText}
                                        </button>
                                    </div>
                                </div>

                                {/* Respuesta del servidor */}
                                {respuestaServidor.message && (
                                    <div className="mt-6 flex justify-center">
                                        <div className="w-full md:w-2/3">
                                            <div className={`p-4 rounded-lg ${
                                                respuestaServidor.type === 'success' ? 'bg-green-100 text-green-800 border border-green-300' :
                                                    respuestaServidor.type === 'danger' ? 'bg-red-100 text-red-800 border border-red-300' :
                                                        respuestaServidor.type === 'warning' ? 'bg-yellow-100 text-yellow-800 border border-yellow-300' :
                                                            'bg-blue-100 text-blue-800 border border-blue-300'
                                            }`} role="alert">
                                                {respuestaServidor.message}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default FormularioAmigo;

if (document.getElementById("form-refiere")) {
    ReactDOM.render(
        <FormularioAmigo />,
        document.getElementById("form-refiere")
    );
}
